/**
 * The reference and tables a texture slot resolves against. A reference that names a resource file
 * means that file's `[resource]` in the file's own tables (`textures/parsedResourceTexture.ts`), so
 * every resolver that reads an inline texture reads a saved one too.
 */
import { useMemo } from 'react';
import { resolveExtResourceFilePath } from './SubResourceResolver.js';
import { parsedResourceTexture } from './textures/parsedResourceTexture.js';
import { useResource } from './useResource.js';
/** The file loads on the `resource` bus, since the image buses decode no resource file. */
export function useParsedResourceSlot(ref, externalResources, internalResources) {
    const path = useMemo(() => resolveExtResourceFilePath(ref, externalResources), [ref, externalResources]);
    const file = useResource(path ?? '', 'resource');
    if (!path)
        return { ref, externalResources, internalResources, status: 'ready' };
    if (!file.value) {
        const status = file.status === 'pending' ? 'loading' : 'missing';
        return { ref: undefined, externalResources, internalResources, status };
    }
    return { ...parsedResourceTexture(file.value), status: 'ready' };
}
//# sourceMappingURL=useParsedResourceSlot.js.map